import { useEffect } from 'react';
import { socketService } from '@services/SocketService';
import { useRoomStore, useUserStore } from '@store/index';

// This hook ensures the socket rejoins the room after navigation
export const useRoomSync = () => {
  const roomCode = useRoomStore((state) => state.roomCode);
  const playerName = useUserStore((state) => state.playerName);
  const playerId = useUserStore((state) => state.playerId);
  
  useEffect(() => {
    if (!roomCode || !socketService.isConnected()) return;
    
    // Check if we need to rejoin the room (after navigation)
    const socketId = socketService.getSocketId();
    if (socketId && socketId !== playerId) {
      console.log('Socket ID changed, may need to sync room state');
      // The backend should handle this via socket room membership
    }
  }, [roomCode, playerName, playerId]);
};